import "components/form/Textarea/Textarea.scss";

function Textarea(props) {
  return (
    <textarea { ...props }/>
  );
}

export default Textarea;
